/* Veloria — couche d'animation : défilement, parallaxe, galerie,
   barre d'achat collante, boutons magnétiques, vol vers le panier */
(() => {
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const fine = matchMedia("(hover: hover) and (pointer: fine)").matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Défilement : en-tête, progression, parallaxe (un seul rAF) */
  const header = $(".site-header");
  const bar = $("[data-progress]");
  const parallax = reduce ? [] : [
    ...$$("[data-parallax] img, [data-parallax] svg").map(el => ({ el, k: 0.12, box: el.closest("[data-parallax]") })),
    ...$$(".it-media img").map(el => ({ el, k: 0.08, box: el.closest(".it-media") }))
  ];
  let ticking = false;
  function frame() {
    ticking = false;
    const y = scrollY, vh = innerHeight;
    if (header) header.classList.toggle("scrolled", y > 24);
    if (bar) {
      const max = document.documentElement.scrollHeight - vh;
      bar.parentElement.style.setProperty("--p", max > 0 ? Math.min(1, y / max).toFixed(4) : 0);
    }
    for (const p of parallax) {
      const r = p.box.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) continue;
      const offset = (r.top + r.height / 2 - vh / 2) * -p.k;
      p.el.style.setProperty("--py", offset.toFixed(1) + "px");
    }
  }
  const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(frame); } };
  addEventListener("scroll", onScroll, { passive: true });
  addEventListener("resize", onScroll, { passive: true });
  frame();

  /* ---------- Fiche produit : fondu au changement d'image */
  const mainImg = $(".g-main img");
  if (mainImg && !reduce) {
    mainImg.addEventListener("load", () => {
      mainImg.classList.remove("swap"); void mainImg.offsetWidth; mainImg.classList.add("swap");
    });
  }

  /* ---------- Zoom suivant la souris (ordinateur) */
  const zoomBox = $("[data-zoom]");
  if (zoomBox && fine && !reduce) {
    zoomBox.addEventListener("mousemove", e => {
      const img = $("img", zoomBox); if (!img) return;
      const r = zoomBox.getBoundingClientRect();
      img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
      zoomBox.classList.add("zooming");
    });
    zoomBox.addEventListener("mouseleave", () => zoomBox.classList.remove("zooming"));
  }

  /* ---------- Galerie glissable (mobile) : points actifs */
  $$("[data-swipe]").forEach(sw => {
    const track = $(".g-track", sw), dots = $$(".g-dots i", sw);
    if (!track || !dots.length) return;
    track.addEventListener("scroll", () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, k) => d.classList.toggle("on", k === i));
    }, { passive: true });
  });

  /* ---------- Barre d'achat collante */
  const sticky = $("[data-sticky-buy]"), buyRow = $("[data-buy-row]");
  if (sticky && buyRow && "IntersectionObserver" in window) {
    let past = false;
    new IntersectionObserver(([e]) => {
      past = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle("show", past);
      sticky.setAttribute("aria-hidden", String(!past));
      const b = $("button", sticky); if (b) b.tabIndex = past ? 0 : -1;
    }).observe(buyRow);
    const sbPrice = $("[data-sb-price]", sticky), sbBtn = $("button", sticky);
    $$('[data-product] input[type=radio][name=id]').forEach(r => r.addEventListener("change", () => {
      if (sbPrice) sbPrice.textContent = r.dataset.price.replace(/<[^>]*>/g, "");
      if (sbBtn) { const ok = r.dataset.available === "true"; sbBtn.disabled = !ok; sbBtn.textContent = ok ? "Ajouter" : "Épuisé"; }
    }));
  }

  /* ---------- Boutons magnétiques (ordinateur) */
  if (fine && !reduce) {
    document.addEventListener("pointermove", e => {
      const b = e.target.closest && e.target.closest(".btn");
      if (!b) return;
      const r = b.getBoundingClientRect();
      b.style.setProperty("--mx", ((e.clientX - r.left - r.width / 2) * 0.18).toFixed(1) + "px");
      b.style.setProperty("--my", ((e.clientY - r.top - r.height / 2) * 0.3).toFixed(1) + "px");
    });
    document.addEventListener("pointerout", e => {
      const b = e.target.closest && e.target.closest(".btn");
      if (b && !b.contains(e.relatedTarget)) { b.style.setProperty("--mx", "0px"); b.style.setProperty("--my", "0px"); }
    });
  }

  /* ---------- Vol de l'image vers le panier après un ajout */
  let flySrc = null;
  document.addEventListener("submit", e => {
    const f = e.target.closest && e.target.closest("form[data-ajax-add]");
    if (!f) return;
    if (f.closest(".drawer")) { const up = f.closest(".up-card"); flySrc = up ? up.querySelector("img") : null; return; }
    const card = f.closest(".card");
    flySrc = card ? $(".thumb img", card) : ($(".g-main img") && getComputedStyle($(".g-main")).display !== "none" ? $(".g-main img") : $(".g-slide img"));
  }, true);
  const badge = $("[data-cart-count]");
  if (badge && !reduce && "MutationObserver" in window) {
    let last = parseInt(badge.textContent, 10) || 0;
    new MutationObserver(() => {
      const n = parseInt(badge.textContent, 10) || 0;
      const src = flySrc; flySrc = null;
      if (n > last && src) fly(src, badge.closest("a") || badge);
      last = n;
    }).observe(badge, { childList: true, characterData: true, subtree: true });
  }
  function fly(img, target) {
    const a = img.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || !b.width || !img.animate) return;
    const size = Math.min(a.width, 160);
    const ghost = document.createElement("div");
    ghost.className = "fly-img";
    ghost.style.cssText = `width:${size}px;height:${size}px;left:${a.left + a.width / 2 - size / 2}px;top:${a.top + a.height / 2 - size / 2}px`;
    ghost.innerHTML = `<img src="${img.currentSrc || img.src}" alt="">`;
    document.body.appendChild(ghost);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    ghost.animate([
      { transform: "translate(0,0) scale(1)", opacity: 1, borderRadius: "6px" },
      { transform: `translate(${dx * 0.5}px,${dy * 0.5 - 60}px) scale(.55)`, opacity: 1, offset: 0.55 },
      { transform: `translate(${dx}px,${dy}px) scale(.12)`, opacity: .2, borderRadius: "50%" }
    ], { duration: 850, easing: "cubic-bezier(.65,0,.35,1)" }).onfinish = () => ghost.remove();
  }

  if (reduce || !("IntersectionObserver" in window)) return;

  /* ---------- Apparitions au défilement (cascade par groupe) */
  const groups = [
    [".rail-head, .coll-head, .coll-bar", "fade"],
    [".grid > .card", null, .08],
    [".circles > .circle", null, .05],
    [".imgtext .it-media", "zoom"],
    [".imgtext .it-copy", null],
    [".trust li", null, .08],
    [".rv", null, .08],
    [".split > *", null, .1],
    [".pdp .info > *", null, .04],
    [".site-footer .fcols > *", null, .06]
  ];
  const targets = [];
  groups.forEach(([sel, kind, step]) => {
    $$(sel).forEach((el, i) => {
      if (el.closest(".hero")) return;
      el.setAttribute("data-reveal", kind || "");
      if (step) el.style.setProperty("--d", `${Math.min(i % 8, 6) * step}s`);
      targets.push(el);
    });
  });
  if (!targets.length) return;

  let fired = false;
  const io = new IntersectionObserver(entries => {
    fired = true;
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });

  document.documentElement.classList.add("motion");
  requestAnimationFrame(() => targets.forEach(el => io.observe(el)));
  // Sécurité : rien ne reste caché si l'observateur ne se déclenche pas
  setTimeout(() => { if (!fired) targets.forEach(el => el.classList.add("in")); }, 2500);
})();
